import { render } from "./DisplayDeliveryReport.vue?vue&type=template&id=19c0f062"
import script from "./DisplayDeliveryReport.vue?vue&type=script&lang=js"
export * from "./DisplayDeliveryReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtn,QTooltip,QMarkupTable,QBadge,QSpinnerHourglass});qInstall(script, 'directives', {ClosePopup});
